/**
 * @generated SignedSource<<141316e8af1418ad9e2b16bcd2236dee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ConferenceCallProvider = "HANGOUTS_MEET" | "MS_TEAMS" | "SKYPE_FOR_BUSINESS" | "UNKNOWN" | "WEBEX" | "ZOOM";
export type RecordingMediaType = "AUDIO" | "VIDEO";
export type RecordingMode = "BOT" | "BOTLESS";
import { FragmentRefs } from "relay-runtime";
export type PreMeetingControls_note$data = {
  readonly event: {
    readonly conferenceCalls: ReadonlyArray<{
      readonly provider: ConferenceCallProvider;
      readonly url: string;
    }>;
  } | null;
  readonly stream: {
    readonly id: string;
    readonly recordingMediaType: RecordingMediaType;
    readonly recordingMode: RecordingMode;
  };
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordToggle_note" | "AutoSendToEveryone_autoShareIsSetToEveryone_note" | "OptionsMenu_note">;
  readonly " $fragmentType": "PreMeetingControls_note";
};
export type PreMeetingControls_note$key = {
  readonly " $data"?: PreMeetingControls_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreMeetingControls_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreMeetingControls_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConferenceCall",
          "kind": "LinkedField",
          "name": "conferenceCalls",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "provider",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recordingMediaType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recordingMode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "AutoSendToEveryone_autoShareIsSetToEveryone_note",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteStream",
          "kind": "LinkedField",
          "name": "stream",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "meetingRecapAutoShareSource",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "sendTo_S",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sendTo",
                      "storageKey": null
                    }
                  ],
                  "type": "StreamMeetingRecapAutoShareSettings",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "sendTo_U",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sendTo",
                      "storageKey": null
                    }
                  ],
                  "type": "UserMeetingRecapAutoShareSettings",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AutoRecordToggle_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OptionsMenu_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "05d51576e2e9d68abf1f8667bb602cc5";

export default node;
